<template>
  <div id="app">
    <AdminPanelBar v-if="$root.disable" :adminBarData="$root.adminBarData" />

    <LoaderSpinner v-if="$root.loading && $root.enable_loader" />

    <!-- Type large -->
    <a
      :href="pageSideImages.url"
      target="_blank"
      rel="nofollow"
      class="background-logo left-side background-logo-large"
      :style="{
        backgroundImage: `url(${pageSideImages.image})`,
        backgroundColor: pageSideImages.background_color,
      }"
      v-if="pageSideImages && pageSideImages.size === 'large'"
    ></a>
    <a
      :href="pageSideImages.url"
      target="_blank"
      rel="nofollow"
      class="background-logo right-side background-logo-large"
      :style="{
        backgroundImage: `url(${pageSideImages.image})`,
        backgroundColor: pageSideImages.background_color,
      }"
      v-if="pageSideImages && pageSideImages.size === 'large'"
    ></a>
    <!-- /Type large -->

    <!-- Type small -->
    <div
      class="background-logo left-side background-logo-small"
      v-if="pageSideImages && pageSideImages.size === 'small'"
    >
      <a :href="pageSideImages.url" target="_blank" rel="nofollow">
        <img :src="pageSideImages.image" />
      </a>
    </div>
    <div
      class="background-logo right-side background-logo-small"
      v-if="pageSideImages && pageSideImages.size === 'small'"
    >
      <a :href="pageSideImages.url" target="_blank" rel="nofollow">
        <img :src="pageSideImages.image" />
      </a>
    </div>
    <!-- /Type small -->

    <template
      v-if="
        headerComponent.regulationBanner &&
          headerComponent.menus &&
          headerComponent.logo
      "
    >
      <Header :headerComponent="headerComponent" />
    </template>

    <router-view />

    <!-- Newsletter update setting with campingn monitor -->
    <template v-if="$root.campaignmonitor.enable_newsletter">
      <Newsletter />
    </template>

    <template
      v-if="footerComponent && $root.show_footer && $root.body_loading_status"
    >
      <Footer :footerComponent="footerComponent" />
    </template>

    <a @click="scrollToTop" id="top-btn" class="to-top" title="to-top">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38">
        <g>
          <g>
            <path
              d="M33,38H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h28c2.8,0,5,2.2,5,5v28C38,35.8,35.8,38,33,38z"
              fill="#373737"
            />
          </g>
          <polygon
            points="19,14.5 22.6,19 26.2,23.5 19,23.5 11.8,23.5 15.4,19"
            fill="#f5f5f5"
          />
        </g>
      </svg>
    </a>
  </div>
</template>

<script>
import Header from "@/components/layouts/Header";
import Footer from "@/components/layouts/Footer";
import LoaderSpinner from "@/components/ui/LoaderSpinner";
import AdminPanelBar from "@/components/layouts/AdminPanelBar";
import Newsletter from "@/components/custom-block/Newsletter";

import { pSBC, getContrastYIQ } from "@/misc/misc-function";
import { HttpService } from "@/api/Pages.api";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    LoaderSpinner,
    AdminPanelBar,
    Newsletter,
  },
  data: function () {
    return {
      headerComponent: {
        regulationBanner: {},
        carnivalBanner: {},
        menus: [],
        logo: "",
      },
      footerComponent: {
        footerMenuTitle1: "",
        footerMenuTitle2: "",
        footerMenuTitle3: "",
        footerMenu1: [],
        footerMenu2: [],
        footerMenu3: [],
        copyright_text: "",
        footer_text2: "",
        securityImages: [],
        socialIcons: [],
        footerMenuCount1: "",
        footerMenuOffset1: "",
        footerMenuText1: "",
        footerMenuLink1: "",
        footerMenuCount2: "",
        footerMenuOffset2: "",
        footerMenuText2: "",
        footerMenuLink2: "",
        footerMenuCount3: "",
        footerMenuOffset3: "",
        footerMenuText3: "",
        footerMenuLink3: "",
      },
      pageLoaded: false,
      pageSideImages: false,
    };
  },
  created: function () {
    let head = document.head || document.getElementsByTagName("head")[0],
      style = document.createElement("style");

    head.appendChild(style);

    style.type = "text/css";
    style.id = "vars-root";

    let varsStyle = document.getElementById("vars-root");
    let primaryBtn = this.$root.color_schema.primary_btn;
    let varsEle = `:root{--primary-btn-hover-color:${
      this.$root.override_ctabtntxt_color
        ? this.$root.ctabtn_txt_color
        : getContrastYIQ(primaryBtn)
        ? "#ffffff"
        : "#222222"
    };--override-primary-btn-text-color:${
      this.$root.override_ctabtntxt_color ? this.$root.ctabtn_txt_color : ""
    };--hover-color:${primaryBtn};--rotate-color:${primaryBtn};--primary-btn:${primaryBtn};--primary-btn-hover:${this.pSBC(
      -0.2,
      primaryBtn
    )};--text-link-color:#0084FF;--primary-color:${this.$root.color_schema.primary};--secondary-color:${
      this.$root.color_schema.secondary
    };--des-color:#fff;--cas-hover-color:#fff;--heading-font:${
      this.$root.font_family.heading
    };--paragraph-font:${this.$root.font_family.paragraph};--default-regular:${
      this.$root.font_family.default_regular
    };--default-bold:${this.$root.font_family.default_bold};--bg-image:url(${
      this.$root.color_schema.site_bg_img
    })repeat;--bg-color:${
      this.$root.color_schema.site_bg_color
    };--search-icon:url(${this.$root.site_url}${
      this.$root.asset_path
    }/svg-icons/search-sml.svg);--primary-search-bg:${this.pSBC(
      0.4,
      this.$root.color_schema.primary
    )};}`;
    if (varsStyle) varsStyle.innerText = varsEle;
  },
  beforeCreate: function () {
    HttpService.getNavLinks(
      this.$root.wp_country && this.$root.wp_country != ""
        ? this.$root.wp_country
        : this.$cookies.get("wp-country"),
      this.$root.wp_state && this.$root.wp_state != ""
        ? this.$root.wp_state
        : this.$cookies.get("wp-state")
    )
      .then((res) => {
        const resData = res.data.data;
        const navMenu = resData.nav_menus;
        this.pageSideImages = this.$root.page_side_images;

        this.headerComponent.menus =
          Object.keys(navMenu.main_menu.items).length > 0
            ? navMenu.main_menu.items
            : [];
        this.headerComponent.logo = resData.logo_url;
        this.headerComponent.regulationBanner = resData.top_ribbon;
        this.headerComponent.carnivalBanner = resData.hasOwnProperty(
          "offer_banner"
        )
          ? resData.offer_banner
          : {};

        // Footer Menu Titles
        this.footerComponent.footerMenuTitle1 =
          navMenu.footer_menu_1 && Object.keys(navMenu.footer_menu_1).length > 0
            ? navMenu.footer_menu_1.name
            : "";
        this.footerComponent.footerMenuTitle2 =
          navMenu.footer_menu_2 && Object.keys(navMenu.footer_menu_2).length > 0
            ? navMenu.footer_menu_2.name
            : "";
        this.footerComponent.footerMenuTitle3 =
          navMenu.footer_menu_3 && Object.keys(navMenu.footer_menu_3).length > 0
            ? navMenu.footer_menu_3.name
            : "";

        // Footer Menus
        this.footerComponent.footerMenu1 =
          navMenu.footer_menu_1 && Object.keys(navMenu.footer_menu_1).length > 0
            ? navMenu.footer_menu_1.items
            : [];
        this.footerComponent.footerMenu2 =
          navMenu.footer_menu_2 && Object.keys(navMenu.footer_menu_2).length > 0
            ? navMenu.footer_menu_2.items
            : [];
        this.footerComponent.footerMenu3 =
          navMenu.footer_menu_3 && Object.keys(navMenu.footer_menu_3).length > 0
            ? navMenu.footer_menu_3.items
            : [];

        // Footer Menus Count, Offset, Label, Link
        this.footerComponent.footerMenuCount1 =
          navMenu.footer_menu_1 &&
          Object.keys(navMenu.footer_menu_1).length > 0 &&
          navMenu.footer_menu_1.count
            ? navMenu.footer_menu_1.count
            : "";
        this.footerComponent.footerMenuOffset1 =
          navMenu.footer_menu_1 &&
          Object.keys(navMenu.footer_menu_1).length > 0 &&
          navMenu.footer_menu_1.offset
            ? parseInt(navMenu.footer_menu_1.offset)
            : navMenu.footer_menu_1 &&
              Object.keys(navMenu.footer_menu_1).length > 0 &&
              navMenu.footer_menu_1.count
            ? navMenu.footer_menu_1.count
            : "";
        this.footerComponent.footerMenuText1 =
          navMenu.footer_menu_1 &&
          Object.keys(navMenu.footer_menu_1).length > 0 &&
          navMenu.footer_menu_1.texts_for_more
            ? navMenu.footer_menu_1.texts_for_more
            : "";
        this.footerComponent.footerMenuLink1 =
          navMenu.footer_menu_1 &&
          Object.keys(navMenu.footer_menu_1).length > 0 &&
          navMenu.footer_menu_1.link_for_more
            ? navMenu.footer_menu_1.link_for_more
            : "";
        this.footerComponent.footerMenuCount2 =
          navMenu.footer_menu_2 &&
          Object.keys(navMenu.footer_menu_2).length > 0 &&
          navMenu.footer_menu_2.count
            ? navMenu.footer_menu_2.count
            : "";
        this.footerComponent.footerMenuOffset2 =
          navMenu.footer_menu_2 &&
          Object.keys(navMenu.footer_menu_2).length > 0 &&
          navMenu.footer_menu_2.offset
            ? parseInt(navMenu.footer_menu_2.offset)
            : navMenu.footer_menu_2 &&
              Object.keys(navMenu.footer_menu_2).length > 0 &&
              navMenu.footer_menu_2.count
            ? navMenu.footer_menu_2.count
            : "";
        this.footerComponent.footerMenuText2 =
          navMenu.footer_menu_2 &&
          Object.keys(navMenu.footer_menu_2).length > 0 &&
          navMenu.footer_menu_2.texts_for_more
            ? navMenu.footer_menu_2.texts_for_more
            : "";
        this.footerComponent.footerMenuLink2 =
          navMenu.footer_menu_2 &&
          Object.keys(navMenu.footer_menu_2).length > 0 &&
          navMenu.footer_menu_2.link_for_more
            ? navMenu.footer_menu_2.link_for_more
            : "";
        this.footerComponent.footerMenuCount3 =
          navMenu.footer_menu_3 &&
          Object.keys(navMenu.footer_menu_3).length > 0 &&
          navMenu.footer_menu_3.count
            ? navMenu.footer_menu_3.count
            : "";
        this.footerComponent.footerMenuOffset3 =
          navMenu.footer_menu_3 &&
          Object.keys(navMenu.footer_menu_3).length > 0 &&
          navMenu.footer_menu_3.offset
            ? parseInt(navMenu.footer_menu_3.offset)
            : navMenu.footer_menu_3 &&
              Object.keys(navMenu.footer_menu_3).length > 0 &&
              navMenu.footer_menu_3.count
            ? navMenu.footer_menu_3.count
            : "";
        this.footerComponent.footerMenuText3 =
          navMenu.footer_menu_3 &&
          Object.keys(navMenu.footer_menu_3).length > 0 &&
          navMenu.footer_menu_3.texts_for_more
            ? navMenu.footer_menu_3.texts_for_more
            : "";
        this.footerComponent.footerMenuLink3 =
          navMenu.footer_menu_3 &&
          Object.keys(navMenu.footer_menu_3).length > 0 &&
          navMenu.footer_menu_3.link_for_more
            ? navMenu.footer_menu_3.link_for_more
            : "";

        // Show Mobile Sticky Menu
        if (this.$root.show_stickymenu) {
          if (this.$root.show_stickymenu_mobile && window.innerWidth < 992) {
            if (this.headerComponent.regulationBanner.show_top_bar) {
              document.body.style.paddingTop = "132px";
            } else if (this.headerComponent.carnivalBanner.enable_banner) {
              document.body.style.paddingTop = "125px";
            } else {
              document.body.style.paddingTop = "80px";
            }
          }
        }
      })
      .catch((err) => console.log(err));

    // To Top Show Hide Event
    window.addEventListener(
      "scroll",
      () => {
        let appDom = document.getElementById("app");
        let reviewDom = document.querySelector(
          "#review-sticky-card .sticky-inner"
        );
        let scTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scTop > 60) {
          appDom.classList.add("scrolling");
          if (reviewDom && reviewDom.getBoundingClientRect().top > 0) {
            document.getElementById("top-btn").style.bottom = `${
              reviewDom.clientHeight + 20
            }px`;
          } else {
            if (window.innerWidth > 991 && window.innerWidth < 1412) {
              document.getElementById("top-btn").style.bottom = "70px";
            } else {
              document.getElementById("top-btn").style.bottom = "20px";
            }
          }
        } else {
          appDom.classList.remove("scrolling");
        }
      },
      { passive: true }
    );

    window.addEventListener("click", (event) => {
      if (!this.$root.enable_piwik_reload) {
        let { target } = event;
        while (target && target.tagName !== "A") target = target.parentNode;
        if (target && target.matches("a:not([href*='://'])") && target.href) {
          const {
            altKey,
            ctrlKey,
            metaKey,
            shiftKey,
            button,
            defaultPrevented,
          } = event;
          if (target.href.includes("javascript")) return;
          // don't handle with control keys
          if (metaKey || altKey || ctrlKey || shiftKey) return;
          // don't handle when preventDefault called
          if (defaultPrevented) return;
          // don't handle right clicks
          if (button !== undefined && button !== 0) return;
          // don't handle if `target="_blank"`
          if (target && target.getAttribute) {
            const linkTarget = target.getAttribute("target");
            if (/\b_blank\b/i.test(linkTarget)) return;
          }
          // don't handle same page links/anchors
          const url = new URL(target.href);
          const to = url.pathname;
          if (window.location.pathname !== to && event.preventDefault) {
            event.preventDefault();
            this.$router.push(to);
          }
        }
      }
    });
  },
  mounted: function () {
    window.addEventListener("resize", this.updateSideAds);
    window.addEventListener("scroll", this.updateSideAdsTop);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.updateSideAds);
    window.removeEventListener("scroll", this.updateSideAdsTop);
  },
  methods: {
    pSBC,
    getContrastYIQ,
    scrollToTop: function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    updateSideAdsTop: function() {
      // This function should only work with "small" banners
      if (!this.pageSideImages || this.pageSideImages.size === "large") return;

      const selectors = [
        ".carnival-banner",
        ".regulation-banner",
        "#header",
        ".panel-wrapper",
      ];

      let offsetTop = 0;

      selectors.forEach((selector) => {
        const item = document.querySelector(selector);

        if (item) {
          const rect = item.getBoundingClientRect();
          const rectHeight = item.offsetHeight || rect.height;

          offsetTop = offsetTop + (rect.top >= -rectHeight ? rectHeight : 0);
        }
      });

      document.querySelectorAll(".background-logo").forEach((item) => {
        item.style.top = `${offsetTop}px`;
      });
    },
    updateSideAds: function() {
      if (!this.pageSideImages) return;

      const bodyWidth = document.body.getBoundingClientRect().width;

      const containerWidth = document.querySelector(".container")
        ? document.querySelector(".container").getBoundingClientRect().width
        : 1240; // Default width
      const finalWidth = (bodyWidth - containerWidth) / 2;

      document.querySelectorAll(".background-logo").forEach((item) => {
        item.style.visibility = "visible";
        item.style.width = `${finalWidth}px`;
      });

      this.updateSideAdsTop();
    },
  },
  watch:{
    '$root.body_loading_status': function() {
      if(this.$root.body_loading_status){
        this.pageLoaded = true;

        HttpService.getFooter(
          this.$root.wp_country && this.$root.wp_country != ""
            ? this.$root.wp_country
            : this.$cookies.get("wp-country"),
          this.$root.wp_state && this.$root.wp_state != ""
            ? this.$root.wp_state
            : this.$cookies.get("wp-state")
        )
          .then((res) => {
            this.footerComponent.copyright_text =
              res.data.data.footer_fields.copyright_text;
            this.footerComponent.footer_text2 =
              res.data.data.footer_fields.footer_text2;
            this.footerComponent.securityImages = res.data.data.security_images;
            this.footerComponent.socialIcons = res.data.data.social_icons;
            this.footerComponent.disclaimer = res.data.data.footer_fields.disclaimer;

            this.updateSideAds();
          })
          .catch((err) => {
            console.log(err);
            this.updateSideAds();
          });
      }
    },
  },
};
</script>

<style lang="less">
@import "~@/assets/less/common";

#app {
  background: @light-gray;
}

.to-top {
  visibility: hidden;
  opacity: 0.7;
  width: 55px;
  height: 55px;
  display: block;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  cursor: pointer;
}

.scrolling {
  .to-top {
    visibility: visible;
  }
}

.ct-inner-banner {
  position: relative;
  z-index: 5;
}

.background-logo {
  position: fixed;
  visibility: hidden;
  transition: top 0.1s ease-in-out;

  &.left-side {
    left: 0;
    text-align: right;
    padding-right: 5px;
  }

  &.right-side {
    right: 0;
    text-align: left;
    padding-left: 5px;
  }

  &-large {
    top: 0;
    height: 100vh;
    z-index: 4;
  }

  &-small {
    z-index: 25;
  }

  @media (max-width: 1270px) {
    &-large {
      display: none;
    }
  }

  @media (max-width: 1600px) {
    &-small {
      display: none;
    }
  }
}

footer {
  position: relative;
  z-index: 5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue